export default function pageChecker() {
    const pageWrapper = document.querySelector('.page-wrapper.page-home');
    const header = document.querySelector('.main-header');

    if (pageWrapper) {
        header.classList.add('is-home-page');
    }
}
